export const easeInOut1 = [0.5, 0, 0.5, 1]
export const easeInOut2 = [0.6, 0, 0.4, 1]
export const easeInOut3 = [0.7, 0, 0.3, 1]

// const spring = {
//   type: "spring",
//   stiffness: 250,
//   damping: 30,
// }
export const defaultTransition = { duration: 0.8, ease: easeInOut2 }
